import { createStyles, Theme } from "@material-ui/core";

export const iosSwitchStyles = (theme: Theme) =>
  createStyles({
    root: {
      width: 36,
      height: 18,
      padding: 0,
      marginRight: theme.spacing(1),
    },
    switchBase: {
      padding: 1,
      "&$checked": {
        transform: "translateX(18px)",
        color: theme.palette.common.white,
        "&.Mui-disabled": {
          color: theme.palette.grey[400],
          "& + $track": {
            backgroundColor: theme.palette.grey[400],
            opacity: 0.5,
            border: "none",
          },
        },
        "& + $track": {
          backgroundColor: "#004B81",
          opacity: 1,
          border: "none",
        },
      },
      "&$focusVisible $thumb": {
        color: "#004B81",
        border: "6px solid #fff",
      },
    },
    thumb: {
      width: 16,
      height: 16,
      "&.Mui-disabled": {
        backgroundColor: theme.palette.grey[300],
      },
    },
    track: {
      borderRadius: 18 / 2,
      border: `1px solid ${theme.palette.grey[400]}`,
      backgroundColor: theme.palette.grey[500],
      opacity: 1,
      transition: theme.transitions.create(["background-color", "border"]),
      "&.Mui-disabled": {
        backgroundColor: theme.palette.grey[400],
        opacity: 0.5,
      },
    },
    checked: {},
    focusVisible: {},
  });
